__turbopack_context__.v({
  "backButton": "pBNvaa_backButton",
  "buttonGroup": "pBNvaa_buttonGroup",
  "buttonsContainer": "pBNvaa_buttonsContainer",
  "contactInfoContainer": "pBNvaa_contactInfoContainer",
  "content": "pBNvaa_content",
  "infoLabel": "pBNvaa_infoLabel",
  "infoWrapper": "pBNvaa_infoWrapper",
  "innerGrid": "pBNvaa_innerGrid",
  "priceWrapper": "pBNvaa_priceWrapper",
  "stickyHeader": "pBNvaa_stickyHeader",
  "stickyHeaderContainer": "pBNvaa_stickyHeaderContainer",
  "title": "pBNvaa_title",
});
